<template>
  <div class="order-detail-tab order-detail-tab--master">
    <template v-if="!orderId">
      <a-empty description="暂无订单数据" />
    </template>
    <template v-else-if="loading">
      <a-spin tip="加载中..." />
    </template>
    <template v-else-if="!hasData">
      <a-empty description="暂无师傅信息" />
    </template>
    <div v-else class="tab-content">
      <a-table
        :columns="columns"
        :data-source="list"
        :pagination="false"
        row-key="id"
      >
        <template slot="avatar" slot-scope="avatar, record">
          <a-avatar v-if="avatar" :src="avatar" :size="40" />
          <a-avatar v-else :size="40">{{ (record.nickname && record.nickname.charAt(0)) || (record.name && record.name.charAt(0)) || '师' }}</a-avatar>
        </template>
        <template slot="creditScore" slot-scope="score">
          <a-progress
            v-if="score != null"
            type="circle"
            :percent="Math.min(100, (score || 0) / 1)"
            :width="44"
            :format="() => (score != null ? score : 0) + ''"
          />
          <span v-else>-</span>
        </template>
        <template slot="commentScore" slot-scope="score">
          <span v-if="score != null" class="comment-stars">{{ starText(score) }}</span>
          <span v-else>-</span>
        </template>
        <template slot="masterOrderStatus" slot-scope="status">
          {{ masterOrderStatusText(status) }}
        </template>
      </a-table>
    </div>
  </div>
</template>

<script>
import { getOrderMasters } from '@/api/order/order'

const MASTER_ORDER_STATUS_MAP = {
  0: '接单中',
  1: '待服务',
  2: '服务中',
  3: '待评价',
  4: '已完成',
  5: '售后中',
  6: '售后完成',
  7: '已关闭'
}

export default {
  name: 'MasterInfo',
  props: {
    orderId: { type: [Number, String], default: null }
  },
  data () {
    return {
      hasData: false,
      loading: false,
      list: [],
      columns: [
        { title: '头像', dataIndex: 'avatar', key: 'avatar', width: 70, scopedSlots: { customRender: 'avatar' } },
        { title: '昵称', dataIndex: 'nickname', key: 'nickname', width: 100, ellipsis: true },
        { title: '姓名', dataIndex: 'name', key: 'name', width: 90, ellipsis: true },
        { title: '手机号', dataIndex: 'mobile', key: 'mobile', width: 120 },
        { title: '信用分', dataIndex: 'creditScore', key: 'creditScore', width: 80, scopedSlots: { customRender: 'creditScore' } },
        { title: '评价分', dataIndex: 'commentScore', key: 'commentScore', width: 100, scopedSlots: { customRender: 'commentScore' } },
        { title: '订单数', dataIndex: 'orderNum', key: 'orderNum', width: 80 },
        { title: '好评率', dataIndex: 'positiveRate', key: 'positiveRate', width: 90, customRender: (val) => val != null ? Number(val).toFixed(1) + '%' : '-' },
        { title: '师傅订单状态', dataIndex: 'masterOrderStatus', key: 'masterOrderStatus', width: 100, scopedSlots: { customRender: 'masterOrderStatus' } },
        { title: '开工码', dataIndex: 'startCode', key: 'startCode', width: 100, ellipsis: true },
      ]
    }
  },
  watch: {
    orderId: {
      immediate: true,
      handler (id) {
        if (id) this.fetchMasters()
        else {
          this.list = []
          this.hasData = false
        }
      }
    }
  },
  methods: {
    async fetchMasters () {
      if (!this.orderId) return
      this.loading = true
      this.hasData = false
      try {
        const res = await getOrderMasters(this.orderId)
        const list = (res && res.data) ? res.data : []
        this.list = list
        this.hasData = Array.isArray(list) && list.length > 0
      } catch (e) {
        this.list = []
        this.hasData = false
      } finally {
        this.loading = false
      }
    },
    starText (score) {
      if (score == null) return '-'
      const s = Number(score)
      const full = Math.floor(s)
      const half = s - full >= 0.5 ? 1 : 0
      const empty = 5 - full - half
      return '★'.repeat(full) + '☆'.repeat(half) + '○'.repeat(empty) + ' ' + s.toFixed(1)
    },
    masterOrderStatusText (status) {
      return MASTER_ORDER_STATUS_MAP[status] != null ? MASTER_ORDER_STATUS_MAP[status] : (status != null ? String(status) : '-')
    }
  }
}
</script>

<style lang="less" scoped>
.order-detail-tab {
  min-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}
.order-detail-tab .tab-content {
  width: 100%;
  padding: 16px;
  align-self: flex-start;
}
.comment-stars {
  white-space: nowrap;
  color: #faad14;
}
</style>
